import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from './hooks/useGeneralTasksStore';
import { GeneralTasksFilters, TaskScope } from './types/generalTasksTypes';
import { MyGeneralTasks } from './myGeneralTasks';
import { useUserStore } from '@roc/feature-app-core';


export const MyGeneralTaskInternal = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const [initializedFilters, setInitializedFilters] = useState<boolean>(false);
  const { userStore } = useUserStore();

  useEffect(() => {
    const initFilters = async () => {
      if (!userStore.userInformation) {
        try {
          const userInfo = await userStore.getUserInformation();
          userStore.setInternalUser(userInfo?.user, null);
        } catch (e) {
          console.error(e);
        }
      }
      generalTasksStore.setCustomFilters({
        [GeneralTasksFilters.TASK_SCOPE]: userStore.isUnderwriter
          ? [{ value: TaskScope.ASSIGNED_TO_ME }]
          : [],
      });
      setInitializedFilters(true);
    };
    initFilters();

    return () => {
      generalTasksStore.setCustomFilters({});
    }
  }, []);

  return <>
    {initializedFilters ? <MyGeneralTasks /> : null}
  </>;
});
